import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MotionConfig } from 'framer-motion';
import { App } from './app/App';
import './styles/tokens.css';
import './styles/globals.css';
import './styles/welcome.css';
import './styles/report.css';
import './styles/briefing.css';
import './styles/cleared.css';
import './styles/play.css';
import './styles/play-hud.css';
import './styles/loading.css';
import { installTelemetry } from './lib/telemetry/bus';
import { installPerfObservers } from './lib/telemetry/perf';
import { installReporter } from './lib/telemetry/reporter';
import './dev-hmr-marker';

installTelemetry();
installPerfObservers();
installReporter();

// Register the service worker (prod only) so the Godot web bundle +
// hashed assets are cache-first on return visits — cuts the cold Play
// load from ~4-7s to near-instant. Guarded so a registration failure
// (unsupported browser, file:// origin) never blocks app boot.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* non-fatal */ });
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    {/* reducedMotion="user" makes every framer-motion animation honour
        the OS prefers-reduced-motion setting (the CSS-var zeroing in
        tokens.css only covered plain CSS transitions). */}
    <MotionConfig reducedMotion="user">
      <App />
    </MotionConfig>
  </StrictMode>,
);
